import React, { FC } from "react";
import { AlertProps } from "@material-ui/lab/Alert";
import { StyledMuiAlert } from './styles';

const Alert: FC<AlertProps> = (props) => {
  return (
    <StyledMuiAlert {...props} />
  );
};

export default Alert;
